import React from "react";

const TextInput = React.forwardRef(
	(
		{
			label,
			required,
			placeholder,
			hideLabel,
			error,
			onChange,
			value,
			name, // Add name prop for React Hook Form
			onBlur,
			autoComplete,
		},
		ref
	) => {
		return (
			<div className="form-field">
				{!hideLabel && (
					<label className="field-label">
						{label}
						{required && <span className="required">*</span>}
					</label>
				)}

				<input
					ref={ref}
					type="text"
					placeholder={placeholder}
					required={required}
					className={error ? "error" : ""}
					name={name}
					onChange={onChange}
					onBlur={onBlur}
					autoComplete={autoComplete}
				/>

				{error && <div className="field__error">{error.message}</div>}
			</div>
		);
	}
);

export default TextInput;
